<template>
  <div class="">
    <p
      v-if="!hideLabel"
      :for="name"
      class="flex items-center gap-2 mb-2 pl-4 text-sm font-medium dark:text-gray-300 text-primary h-5"
    >
      {{ $t(label || "") }}<span v-if="required" class="text-danger"> *</span>
    </p>
    <div class="flex items-center">
      <div class="flex items-center">
        <input
          :type="type"
          :id="id"
          :name="name"
          :checked="checked"
          v-model="value"
          class="text-primary transition-all duration-100 ease-out form-checkbox rounded-sm"
          :class="[
            {
              'input-error': errorMessage,
            },

            size ? 'h-7 w-7 md:h-10 md:w-10' : 'h-5 w-5',
          ]"
        />
        <label :for="id"></label>
      </div>
      <label
        :for="id"
        class="ml-3 flex items-center gap-2 dark:text-gray-300"
        :class="[
          { 'text-secondary': errorMessage },
          { 'text-lg md:text-2xl font-semibold': size },
        ]"
        ><slot>{{ $t(text || "") }}</slot>
        <tippy v-if="tooltip" class="flex items-center justify-center">
          <BaseIcon name="info" class="text-success hover:ring-success" />
          <template #content>
            <slot name="tooltip" />
          </template> </tippy
      ></label>
    </div>
    <span
      v-if="single"
      v-show="errorMessage"
      class="text-danger dark:text-danger"
    >
      {{ $t(errorMessage || "") }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from "vue";
import { useField } from "vee-validate";
// import { useVModel } from "@vueuse/core";

const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
  label: String,
  text: String,
  name: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: "checkbox",
  },
  size: {
    type: Boolean,
    default: false,
  },
  id: String,
  placeholder: String,
  cvalue: {
    type: [Boolean, String, Number],
    default: false,
  },
  modelValue: {
    type: [Boolean, String, Number],
    default: true,
  },
  btn: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
  single: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: true,
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: false,
  },
});

const { checkedValue, uncheckedValue, modelValue } = toRefs(props);

const { value, errorMessage, checked } = useField(() => props.name, undefined, {
  initialValue: modelValue,
  type: props.type,
  checkedValue: checkedValue,
  // valueProp: toRef(props, "modelValue"),
  uncheckedValue: uncheckedValue,
  syncVModel: true,
});
// handleChange(modelValue.value);
// const onChange = (e) => {
//   const v = e.target.checked ? checkedValue.value : uncheckedValue.value;
//   // console.log('v :>> ', v);
//   // emit("update:modelValue", v);
// };
</script>

<style scoped></style>
